import { format as originalFormat } from "date-fns";
import locale from "./dateFnLocale";

export function format(date: Date, formatStr = "PP") {
  return originalFormat(date, formatStr, {
    locale,
  });
}
